<template>
    <div class="auth_success">
        <el-image :src="url" fit="fill"></el-image>
        <div>扫码创建</div>
        <el-button @click="back()">创建完成 返回查看</el-button>
    </div>
</template>

<style>
.auth_success {
    width: 300px;
    height: 100%;
    text-align: center;
    padding-top: 15%;
    line-height: 200%;
    margin: auto;
}
</style>


<script>
export default {
    data() {
        return {
            url: ''
        };
    },
    created() {
        this.Data.ComponentApp.GetTryAuthLink(this.$route.query.code).then(res => {
            this.url = 'http://tool.h5-x.com/image/qrcode?txt=' + encodeURIComponent(res.data);
        });
    },
    methods: {
        back() {
            if (window.opener) window.opener.location.reload()
            window.open("about:blank", "_top").close()
        },
    },
};
</script>